'use client';

import { useFormContext, useWatch } from 'react-hook-form';
import { EpStepContent, EpStepSelect } from '../components';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { userService } from '../../../services/userService';

export default function UnitInput({ translations }: { translations: unknown }) {
  const { setValue } = useFormContext();

  const inpatientsUnitsTerm = t(translations, 'Inpatients unit');
  const otherUnitsTerm = t(translations, 'Other Units');
  const tenantsServiceMonitored = userService.getTenantsUnits({
    Enabled: true,
    Monitored: 'true',
  });

  const tenantsServiceNotMonitored = userService.getTenantsUnits({
    Enabled: true,
    Monitored: 'false',
  });

  const NotificationIncident = useWatch({
    name: 'notificationIncidentId.inputValue',
  });

  const takeUnitsArr = () => {
    if (
      tenantsServiceMonitored?.data?.itens?.length < 0 &&
      tenantsServiceNotMonitored?.data?.itens?.length < 0
    )
      return [];

    const monitoredObjects =
      tenantsServiceMonitored?.data?.itens?.length > 0
        ? tenantsServiceMonitored?.data?.itens
        : [];
    const notMonitoredObjects =
      tenantsServiceNotMonitored?.data?.itens?.length > 0
        ? tenantsServiceNotMonitored?.data?.itens
        : [];

    return [
      {
        id: 0,
        name: inpatientsUnitsTerm,
        disabled: true,
      },
      ...monitoredObjects,
      {
        id: 0,
        name: otherUnitsTerm,
        disabled: true,
      },
      ...notMonitoredObjects,
    ];
  };

  if (
    tenantsServiceMonitored?.isFetching ||
    tenantsServiceNotMonitored?.isFetching
  )
    return null;

  return (
    <EpStepContent.Label
      helpIconText={t(
        translations,
        'You should select the unit where the incident occurred.',
      )}
      label={t(translations, 'Ocurrence local') + ' *'}
    >
      <EpStepSelect
        data={takeUnitsArr()}
        disabled={NotificationIncident === ''}
        errorMessage={t(translations, '* Required Fied')}
        registerId={'unitId'}
        selectOnChange={() => {
          setValue('formUtils.stepNeedReview', '');
        }}
      />
    </EpStepContent.Label>
  );
}
